// extracted by mini-css-extract-plugin
export var chevron = "_2w-d";
export var disabled = "_2w-b";
export var error = "_2w-c";
export var hideBorder = "_2w-1";
export var icon = "_2w-e";
export var input = "_2w-0";
export var large = "_2w-f";
export var open = "_2w-9";
export var placeholder = "_2w-a";
export var regular = "_2w-5";
export var singleRowInput = "_2w-2";
export var singleSelectInput = "_2w-3 _2w-0";
export var small = "_2w-4";
export var spinnerContainer = "_2w-i";
export var tag = "_2w-7";
export var tagsContainer = "_2w-8";
export var tagsInput = "_2w-6 _2w-0";
export var xSmall = "_2w-g";
export var xxSmall = "_2w-h";